// extracted by mini-css-extract-plugin
module.exports = {"Icon":"Industry_Icon__29y8R","Industry":"Industry_Industry__2VFQx"};